import React from 'react';
import ExperienceRiskBadge from './ExperienceRiskBadge';

const ProactiveOutreachPanel = ({ items = [] }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="text-sm font-semibold text-slate-100">Pelanggan Prioritas Outreach</h3>
    <div className="mt-3 space-y-2">
      {items.slice(0, 12).map((item, idx) => (
        <div key={`outreach-${item.customerId}-${idx}`} className="rounded-lg border border-slate-800 bg-slate-950/60 p-2.5 text-xs text-slate-300">
          <div className="flex items-center justify-between gap-2">
            <div className="font-medium text-slate-100">{item.customerId}</div>
            <ExperienceRiskBadge level={item.priority} />
          </div>
          <div className="mt-1 text-slate-400">Alasan: {item.reason}</div>
          <div className="mt-1 text-slate-400">Channel: {item.channelSuggestion} � Template: {item.recommendedMessageType}</div>
        </div>
      ))}
      {!items.length ? <div className="text-xs text-slate-500">Belum ada kandidat outreach.</div> : null}
    </div>
  </section>
);

export default ProactiveOutreachPanel;
